import React, { useState } from "react";
import {
  Alert,
  Button,
  ButtonGroup,
  Card,
  Col,
  Form,
  Row,
  Modal,
  Spinner,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import CustomPagint from "../../../CustomPagint";
import {
  getPreguntasPlantillaCuestionarios,
  guardarImportarPreguntasPlantillaCuestionario,
} from "../../../../redux/climalaboral/plantillaCuestionario/action";

const ImportQuestion = (props) => {
  const [selectedItem, setSelectedItem] = useState([]);

  const dispatch = useDispatch();

  const {
    surveyImportLoading,
    surveyTemplateImport,
    surveyTemplateImportFail,
    saveLoaderImport,
    formImportError,

    // Para preguntas plantilla cuestionario
    questionLoading,
    question,
    questionFail,
  } = useSelector((store) => store.plantillaCuestionario);
  const pages = Math.ceil(
    surveyTemplateImport ? surveyTemplateImport.count / props.limit : 0
  );

  const openImport = (item) => {
    // props.setShowModal(false);
    props.setShowModalPreguntasImport(true);
    dispatch(
      getPreguntasPlantillaCuestionarios({
        tipo_busqueda: "cuestionario_id",
        filter: parseInt(item.id),
      })
    );
  };

  const handleCheckbox = ({ target: { checked, value: checkValue } }) => {
    if (checked) {
      setSelectedItem([...selectedItem, checkValue]);
    } else {
      setSelectedItem(selectedItem.filter((e) => e !== checkValue));
    }
  };

  const guardarImportacion = () => {
    let req = { cuestionario_id: parseInt(props.id), preguntas_ids: [] };
    selectedItem.map((item) => {
      req.preguntas_ids.push(item);
    });
    dispatch(
      guardarImportarPreguntasPlantillaCuestionario(
        req,
        props.setShowModal,
        props.setShowModalPreguntasImport,
        props.preguntas,
        props.setPreguntas
      )
    );
  };

  const seeAll = () => {
    const oSearch = "";
    props.setFilter(oSearch);
    const oOffset = 0;
    props.setOffset(oOffset);
    props.setCurrentPage(1);
    props.getAPlantillas(oOffset, props.limit, oSearch);
  };

  const onSearch = (e) => {
    e.preventDefault();
    props.setFilter(e.target.filter.value);
    const oOffset = 0;
    props.setOffset(oOffset);
    props.setCurrentPage(1);
    props.getAPlantillas(oOffset, props.limit, e.target.filter.value);
  };

  return (
    <>
      <Modal
        size="xl"
        show={props.showModal}
        onHide={() => props.setShowModal(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>Importar preguntas</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ height: "100%", overflowY: "auto" }}>
          <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
            <h6 className="font-weight-bold text-uppercase">Cuestionarios</h6>
            <Form onSubmit={onSearch}>
              <Row className="justify-content-end align-items-center flex-nowrap">
                <Col xs="auto">
                  <Form.Control
                    name="filter"
                    id="filter"
                    placeholder="Buscar"
                    className="rounded-pill form-control-sm"
                    type="search"
                  ></Form.Control>
                </Col>
                <Col xs="auto">
                  <ButtonGroup>
                    <Button
                      onClick={() => seeAll()}
                      variant="light"
                      size="sm"
                      className="rounded-circle"
                    >
                      <i className="material-icons">list</i>
                    </Button>
                  </ButtonGroup>
                </Col>
              </Row>
            </Form>
          </div>
          <div className="px-2">
            <hr />
          </div>
          <Row className="px-2">
            {surveyImportLoading ? (
              <div className="d-flex justify-content-center mt-4">
                <Spinner
                  animation="border"
                  role="status"
                  className="d-flex justify-content-center"
                />
              </div>
            ) : (
              <>
                {!!surveyTemplateImportFail && (
                  <Col>
                    <Alert variant="danger" className="mt-1 mb-3">
                      {surveyTemplateImportFail}
                    </Alert>
                  </Col>
                )}
                {surveyTemplateImport && surveyTemplateImport.count > 0 ? (
                  surveyTemplateImport.data.map((item) => (
                    <>
                      <Col md="3" className="mb-2">
                        <Card
                          // className="h-100 shadow-sm bg-white rounded tarjetaButton"
                          className="shadow-sm bg-white rounded tarjetaButton"
                          onClick={() => openImport(item)}
                        >
                          <Card.Header className="flex-wrap justify-content-center align-items-center text-justify btn-primary buttonHeader">
                            {item.nombre}
                          </Card.Header>
                          <Card.Body
                            className="flex-wrap justify-content-center align-items-center text-justify"
                            style={{ overflowY: "auto", height: "160px" }}
                          >
                            <Card.Text>{item.descripcion}</Card.Text>
                          </Card.Body>
                        </Card>
                      </Col>
                    </>
                  ))
                ) : (
                  <Col>
                    <Alert className="mt-1 mb-3" variant="info">
                      Aún no hay cuestionarios registrados, comience agregando
                      algunos.
                    </Alert>
                  </Col>
                )}
              </>
            )}
          </Row>
          <>
            <CustomPagint
              limit={props.limit}
              setLimit={props.setLimit}
              offset={props.offset}
              setOffset={props.setOffset}
              currentPage={props.currentPage}
              setCurrentPage={props.setCurrentPage}
              dataLenght={surveyTemplateImport ? surveyTemplateImport.count : 0}
              pages={pages}
              pagFunc={props.getAPlantillas}
            />
          </>
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal>
      <Modal
        size="lg"
        show={props.showModalPreguntasImport}
        onHide={() => props.setShowModalPreguntasImport(false)}
      >
        <Form>
          <Modal.Header closeButton>
            <Modal.Title>Importar preguntas</Modal.Title>
          </Modal.Header>
          <Modal.Body
            style={{
              height: "100%",
              overflowY: "auto",
              maxHeight: "calc(100vh - 210px)",
            }}
          >
            {questionLoading ? (
              <div className="d-flex justify-content-center">
                <Spinner
                  animation="border"
                  role="status"
                  className="d-flex justify-content-center"
                />
              </div>
            ) : (
              <>
                {!!questionFail && (
                  <Col>
                    <Alert variant="danger" className="mt-1 mb-3">
                      {questionFail}
                    </Alert>
                  </Col>
                )}
                {!!formImportError && (
                  <Col>
                    <Alert variant="danger" className="mt-1 mb-3">
                      {formImportError}
                    </Alert>
                  </Col>
                )}
                {question && question.count > 0 ? (
                  question.data
                    .sort((a, b) =>
                      a.posicion > b.posicion
                        ? 1
                        : b.posicion > a.posicion
                        ? -1
                        : 0
                    )
                    .map((item) => (
                      <>
                        <Col
                          sm="12"
                          md="12"
                          lg="12"
                          xl="12"
                          className="mb-2 flex-wrap justify-content-between align-items-between text-justify"
                        >
                          <Row key={item.id}>
                            <Col
                              sm="1"
                              md="1"
                              lg="1"
                              xl="1"
                              className="d-flex flex-wrap justify-content-center align-items-center text-justify"
                            >
                              <input
                                onChange={handleCheckbox}
                                className=""
                                type="checkbox"
                                name="allemployyes1[]"
                                value={item.id}
                              />
                            </Col>
                            <Col
                              sm="10"
                              md="10"
                              lg="10"
                              xl="10"
                              style={{ border: "1px solid #ced4da" }}
                              className="pl-3 pr-3 pt-3 pb-3 bg-white shadow-sm rounded d-flex flex-wrap justify-content-center align-items-center"
                            >
                              <Col
                                style={{
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}
                              >
                                {item.pregunta}
                              </Col>
                            </Col>
                          </Row>
                        </Col>
                      </>
                    ))
                ) : (
                  <Col>
                    <Alert className="my-4" variant="info">
                      Aún no hay preguntas registradas para este cuestionario.
                    </Alert>
                  </Col>
                )}
              </>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="rounded-pill"
              variant="primary"
              onClick={guardarImportacion}
              type="button"
              disabled={questionLoading || saveLoaderImport}
            >
              {questionLoading || saveLoaderImport ? (
                <div className="d-flex justify-content-center">
                  <Spinner
                    className="mr-2"
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                </div>
              ) : null}
              importar
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
};

export default ImportQuestion;
